export default __webpack_public_path__ + "static/media/Shoes3.55018003.png";